export default __webpack_public_path__ + "static/media/click2.73d9e655.ogg";